<li class="timeline-item body-bold">
  <span class="timeline-item__header">
    <vtmn-play-icon *ngIf="iconType" [name]="iconType"></vtmn-play-icon>
    {{ headerContent }}
  </span>
  {{ content }}
</li>
